import { render, staticRenderFns } from "./QueryMousePosLegacy.vue?vue&type=template&id=00ca0051&"
import script from "./QueryMousePosLegacy.vue?vue&type=script&lang=js&"
export * from "./QueryMousePosLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports